<section class="flex mb-4">
    <div class="flex-1 flex flex-col">
        <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
            Reinyeccion de transaccion
        </span>

    </div>
</section>
<div class="flex-1" id="dashboardSalesDetailContainer"></div>

<!-- Status Message -->
<div class="flex justify-center mb-6">
    <div class="bg-blue-50 border border-blue-200 rounded-lg px-6 py-4 max-w-md text-center">
        <p class="text-blue-600 text-sm leading-relaxed">
            La reinyección está en proceso. Los cambios pueden tardar hasta un minuto en reflejarse en el portal.
        </p>
    </div>
</div>

<section class="botoncito mt-auto items-center flex">
    <a routerLink="/conciliaciones-v2"
        class="mx-auto w-60 px-[25px] py-[10px] bg-indigo-300 rounded-[14px] text-center items-center align-middle cursor-pointer hover:bg-indigo-400 transition-colors">
        <span class="text-white font-semibold font-['Inter']">
            Volver
        </span>
    </a>
</section>